"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const eq_js_1 = __importDefault(require("../eq.js"));
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
    let { length } = array;
    while (length--) {
        if ((0, eq_js_1.default)(array[length][0], key)) {
            return length;
        }
    }
    return -1;
}
exports.default = assocIndexOf;
